import { protectedAxiosInstance, axiosInstance, zeroParamProtectedAxiosInstance } from 'helpers/api-calls';
import { BASE_URL } from '../../constants';
import { createHeadersForApiCall, getUserId, getSessionUukey, createHeadersForPDFUploading, createHeadersForUploadImage } from '../cookies';
import { StatusCheck } from '../authentication';

const getChatSessions = (params) =>
  protectedAxiosInstance.request({
    url: '/api/customer/user_role/chat_sessions',
    method: 'GET',
    params,
  });

const getChatMessages = (chatSessionId, params) =>
  protectedAxiosInstance.request({
    url: `/api/customer/user_role/chat_sessions/${chatSessionId}/chat_messages`,
    method: 'GET',
    params,
  });

const getOneChatMessage = (chatSessionId, chatMessageId) =>
  protectedAxiosInstance.request({
    url: `/api/customer/user_role/chat_sessions/${chatSessionId}/chat_messages/${chatMessageId}`,
    method: 'GET',
  });

const getOneChatSession = (chatSessionId, chatMessageId) =>
  protectedAxiosInstance.request({
    url: `/api/customer/user_role/chat_sessions/${chatSessionId}`,
    method: 'GET',
  });

const archiveChatSession = (chatSessionId) =>
  protectedAxiosInstance.request({
    url: `/api/customer/user_role/chat_sessions/${chatSessionId}/archive`,
    method: 'PUT',
  });

const getPosts = (params) =>
  protectedAxiosInstance.request({
    url: '/api/customer/user_role/posts',
    method: 'GET',
    params,
  });

export const getOnePost = (postId) =>
  protectedAxiosInstance.request({
    url: `/api/customer/user_role/posts/${postId}`,
    method: 'GET',
  });

const getPostLikeOwnerIds = (postId) =>
  protectedAxiosInstance.request({
    url: `/api/compact/posts/${postId}/like_owner_ids`,
    method: 'GET',
    params: {
      per_page: 10000,
    },
  });

const deletePost = (postId) =>
  protectedAxiosInstance.request({
    url: `/api/customer/user_role/posts/${postId}`,
    method: 'DELETE',
  });

const getComments = (params) =>
  protectedAxiosInstance.request({
    url: '/api/customer/user_role/comments',
    method: 'GET',
    params,
  });

const deleteComment = (commentId) =>
  protectedAxiosInstance.request({
    url: `/api/customer/user_role/comments/${commentId}`,
    method: 'DELETE',
  });

const likePost = (postId) =>
  protectedAxiosInstance.request({
    url: `/api/customer/user_role/posts/${postId}/like`,
    method: 'PUT',
  });

const unlikePost = (postId) =>
  protectedAxiosInstance.request({
    url: `/api/customer/user_role/posts/${postId}/unlike`,
    method: 'PUT',
  });

const readPost = (postId) =>
  protectedAxiosInstance.request({
    url: `/api/customer/user_role/posts/${postId}/read`,
    method: 'PUT',
  });

const pinPost = (postId) =>
  protectedAxiosInstance.request({
    url: `/api/customer/user_role/posts/${postId}/pin`,
    method: 'PUT',
  });

const unpinPost = (postId) =>
  protectedAxiosInstance.request({
    url: `/api/customer/user_role/posts/${postId}/unpin`,
    method: 'PUT',
  });

const getReadReceipts = (postId) =>
  protectedAxiosInstance.request({
    url: `/api/customer/user_role/posts/${postId}/receipts`,
    method: 'GET',
    params: {
      per_page: 10000,
    },
  });
const getReadReceiptIds = (postId) =>
  protectedAxiosInstance.request({
    url: `/api/compact/posts/${postId}/receipt_user_ids`,
    method: 'GET',
    params: {
      per_page: 10000,
    },
  });

const getChannelMembers = (channelId) =>
  protectedAxiosInstance.request({
    url: `/api/customer/user_role/channels/${channelId}/member_users`,
    method: 'GET',
    params: {
      per_page: 10000,
    },
  });

const getSubscriptions = (channelId) =>
  protectedAxiosInstance.request({
    url: `/api/customer/user_role/channels/${channelId}/subscriptions`,
    method: 'GET',
    params: {
      per_page: 10000,
    },
  });

const putChannelInfo = (channelId, name, description) =>
  protectedAxiosInstance.request({
    url: `/api/customer/user_role/channels/${channelId}`,
    method: 'PUT',
    data: {
      channel: {
        channel_name: name,
        description: description,
      },
    },
  });

const addUserToChannel = (userId, channelId, subscriptionId) => {
  console.log('addUserToChannel', userId, channelId, subscriptionId);
  return protectedAxiosInstance.request({
    url: `/api/customer/user_role/subscriptions/`,
    method: 'POST',
    data: {
      subscription: {
        channel_id: channelId,
        user_id: userId,
      },
    },
  });
}

const removeUserFromChannel = (userId, channelId, subscriptionId) => {
  console.log('removeUserFromChannel', userId, channelId, subscriptionId);
  return protectedAxiosInstance.put(
    `/api/customer/user_role/channels/${channelId}/remove_user?user_id=${userId}`,
    {
      params: {
        userId,
        channelId,
      },
    },

  );
}
const putSubscriptionMuteInfo = (channelId, subscriptionId, muteStatus) =>
  protectedAxiosInstance.request({
    url: `/api/customer/user_role/subscriptions/${subscriptionId}`,
    method: 'PUT',
    data: {
      subscription: {
        subscription_mute_notifications: muteStatus,
      },
    },
  });

const createPost = (post) =>
  protectedAxiosInstance.request({
    url: '/api/customer/user_role/posts',
    method: 'POST',
    data: {
      post: post,
    },
  });

const createChatMessage = (chat_session_id, chatMessage) =>
  protectedAxiosInstance.request({
    url: '/api/customer/user_role/chat_sessions/' + chat_session_id + '/chat_messages',
    method: 'POST',
    data: {
      chat_message: chatMessage,
    },
  });

const createChatSession = (selectedUserId, currentUserId, locationId) => {

  const payload = {
    chat_session: {
      user_ids: [selectedUserId, currentUserId],
      location_id: locationId,
    },
  };

  return protectedAxiosInstance.request({
    url: '/api/customer/user_role/chat_sessions/',
    method: 'POST',
    data: payload,
  });
};

export function createComment(content, source_id) {
  const data = {
    content,
    source_id,
    owner_id: getUserId(),
  };

  return fetch(`${BASE_URL}/api/organization/comments`, {
    headers: createHeadersForApiCall(),
    method: 'POST',
    body: JSON.stringify(data),
  }).then((response) => {
    StatusCheck(response.status);
    return response.json();
  });

};


/**
 * UploadImage
 *
 * @param  {String} base64 image data url
 * @return {type}        description
 */
export function UploadImage(imageDataUrl, succeededCallback, failedCallback) {

  const payload = {
    "image": {
      "image_name": "post_image",
      "avatar_base": imageDataUrl,
    }
  }

  return fetch(`${BASE_URL}/api/customer/user_role/images?response[put_return_resource]=true`, {
    method: 'POST',
    headers: createHeadersForUploadImage(),
    body: JSON.stringify(payload)

  }).then((response) => {
    return response.json();
  });
}

/**
 * UploadMessageImage
 *
 * @param  {String} base64 image data url
 * @return {type}        description
 */
export function UploadChatMessageImage(imageDataUrl) {

  const payload = {
    "image": {
      "image_name": "message_image",
      "avatar_base": imageDataUrl,
    }
  }

  return fetch(`${BASE_URL}/api/customer/user_role/images?response[put_return_resource]=true`, {
    method: 'POST',
    headers: createHeadersForUploadImage(),
    body: JSON.stringify(payload)

  }).then((response) => {
    return response.json();
  });
}

/**
 * UnfurlURL
 *
 * @param  {String} user input url
 * @return {type}   description
 */
export function UnfurlURL(url) {

  return axiosInstance.request({
    url: `https://test-unfurl.myshyft.com/?url=${url}`,
    method: 'GET',
  });
}

export function UploadPDF(pdf) {
  var formData = new FormData();
  formData.append('file', pdf.file);

  /*
  //It is fine for uploading PDF, but the uploaded PDF cannot be displayed when clicking
  const blob = new Blob([JSON.stringify(pdf.dataUrl)], {type : 'application/pdf'});
  formData.append("file", blob, pdf.name);
  */
  return fetch(`${BASE_URL}/api/customer/uploader/file`, {
    headers: createHeadersForPDFUploading(),
    method: 'POST',
    body: formData,
  }).then((response) => {
    return response.json();
  }).catch((error) => {
    console.log(error);
  });

};

export function UploadPDF2(pdf) {
  var data = new FormData();
  //data.append("file", pdf.file, pdf.name);

  const blob = new Blob([JSON.stringify(pdf.dataUrl)], { type: 'application/pdf' });
  data.append("file", blob);

  var xhr = new XMLHttpRequest();
  xhr.withCredentials = true;

  xhr.addEventListener("readystatechange", function () {
    if (this.readyState === 4) {
      console.log(this.responseText);
    }
  });

  xhr.open("POST", `${BASE_URL}/api/customer/uploader/file?response[put_return_resource]=true`);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.setRequestHeader('Session-Uukey', getSessionUukey());

  xhr.send(data);

};

export const LoadApplicantPosts = (applicantId) =>
  protectedAxiosInstance.request({
    url: `/api/compact/applicants/${applicantId}/free_posts`,
    method: 'GET',
  });

export const CreateApplicantFreePost = (applicantId, content) => {
  const freePostJson = {
    postable_id: applicantId,
    postable_type: "Applicant",
    content: content,
    title: "Free Post",
    post_type: "22"
  };

  return zeroParamProtectedAxiosInstance.request({
    url: `/api/customer/user_role/posts`,
    method: 'POST',
    data: {
      post: freePostJson,
    },
  });
}

export default {
  removeUserFromChannel,
  addUserToChannel,
  getChatSessions,
  getChatMessages,
  getOneChatMessage,
  getOneChatSession,
  archiveChatSession,
  getPosts,
  deletePost,
  getComments,
  deleteComment,
  likePost,
  unlikePost,
  readPost,
  getReadReceipts,
  getChannelMembers,
  getSubscriptions,
  createPost,
  createChatMessage,
  createChatSession,
  createComment,
  pinPost,
  unpinPost,
  getPostLikeOwnerIds,
  getReadReceiptIds,
  putChannelInfo,
  putSubscriptionMuteInfo,
  getOnePost,
  CreateApplicantFreePost,
};

